<template>
  <div class="widget__content-center widget__content-center--flex">
    <!-- Zone Daily -->
    <div v-if="chartSeries && area?.name === 'Zone'" class="chart-wrapper">
      <apexchart
        v-if="chartSeries"
        type="area"
        height="100%"
        width="100%"
        :options="chartOptions"
        :series="chartSeries"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import dayjs from 'dayjs';
import { secToMinHrSec, secToMin } from '@/utils/formatTimeSpent';
import type { WidgetFilter, WidgetSetting, WidgetTypeEngagedVisitorDwell } from '@/types/Widget';
import { type BaseChartOptions } from '@/utils/chartSettings';
import { getChartExportSettings, getDefaultChartOptions } from '@/utils/chartSettings';

const props = defineProps<{
  widget: WidgetTypeEngagedVisitorDwell;
  area?: WidgetFilter;
  zone?: WidgetSetting;
}>();

const baseChartOptions = getDefaultChartOptions(props.widget.code_name);

const chartSeries = computed(() => {
  if (!props.zone?.id) {
    return [];
  }

  const daysData = props.widget.data.Zone[props.zone?.id]['Day'];
  const dates = Object.keys(daysData);

  return [
    {
      name: 'Dwell',
      data: dates.map((date) => {
        return {
          x: date,
          y: daysData[date].Dwell,
        };
      }),
    },
  ];
});

const chartOptions = computed<BaseChartOptions>(() => {
  return {
    ...baseChartOptions.value,
    chart: {
      ...baseChartOptions.value.chart,
      type: 'area',
      id: 'meshh-chart-dwell-daily',
      toolbar: getChartExportSettings(
        props.widget.name,
        props.area?.name || '',
        'Day',
        props.zone?.title || '',
        '',
        '',
      ),
    },
    dataLabels: {
      enabled: false,
    },
    stroke: {
      curve: 'straight',
    },
    title: {
      text: 'Visitor Dwell Time',
      align: 'left',
    },
    tooltip: {
      y: {
        formatter: (val: number) => {
          return secToMinHrSec(val).text;
        },
      },
    },
    xaxis: {
      type: 'date',
      tooltip: {
        enabled: false,
      },
      labels: {
        formatter: (val: string) => {
          return dayjs(val).format('DD MMM YYYY');
        },
      },
    },
    yaxis: {
      show: true,
      title: {
        text: 'Dwell Time (mins)',
      },
      labels: {
        formatter: (val: number) => {
          return `${secToMin(val)}m`;
        },
      },
    },
    legend: {
      ...baseChartOptions.value.legend,
      horizontalAlign: 'left',
    },
  };
});
</script>
